module.exports = __webpack_public_path__ + "build/img/06.28512949.jpg";